import React, { Component } from 'react';

import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import Toast from 'light-toast';
import { FaCloud, FaCog, FaFilter, FaLayerGroup, FaTrash } from 'react-icons/fa';
import './styles.css';

import StructurePopover from './structurePopover';

import cookies from '../utils/cookies.util';
import base_url, { bucket_name, region } from '../utils/request.util';

const column_names = {
  // "Barrier": "Barrier",
  // "Strike": "Strike",

  Code: 'code',
  Name: 'name',
  Sector: 'sector',
  Industry: 'industry',
  'Initial Price': 'initial_reference_price',
  'Last Price': 'last_price',

  'Basket Price Latest': 'basket_price_latest',

  'Barrier Price': 'barrier_level',
  'Strike Price': 'strike_level',
  'Coupon Level': 'coupon_level',
  'Autocall Level': 'autocall_level',
  'Next Autocall Level': 'next_autocall_level',
  'Next Autocall %': 'autocall_percentage',

  'Maturity Date': 'date_determination',
  'First Autocall Date': 'first_autocall_date',
  'Next Autocall Date': 'next_autocall_date',
  'Initial Fixing Date': 'initial_fixing_date',

  '% Change': 'percentage_change',
  'Distance To Autocall': 'percentage_distance_from_autocall',
  'Distance To Barrier': 'percentage_distance_from_barrier',
  'Distance To Coupon': 'percentage_distance_from_coupon',
  'Distance To Strike': 'percentage_distance_from_strike',

  Status: 'status',
  Type: 'type'
};

function getCodes(underlying) {
  const codesList = [];
  underlying.forEach((element) => {
    codesList.push(element.code.split(' ')[0]);
  });
  return codesList.join('-');
}

class DispersionWarrentStructures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      underlying_count: {},
      holding_count: {},
      product_details: [],
      show_basic: window.location.pathname !== '/structure/dispersion-warrent/ideas',
      show_fundamentals: false,
      show_params: window.location.pathname === '/structure/dispersion-warrent/ideas',
      coupon_type: 'All',
      coupon_min: 0,
      coupon_max: 100,
      tenor_min: 0,
      tenor_max: 120,
      barrier_min: 0,
      barrier_max: 100,
      strike_min: 0,
      strike_max: 100
    };
    this.updateColumnName = this.updateColumnName.bind(this);
    this.saveConfig = this.saveConfig.bind(this);
    this.resetConfig = this.resetConfig.bind(this);
    this.toggleCompoentShow = this.toggleCompoentShow.bind(this);
    this.updateFilter = this.updateFilter.bind(this);
    this.saveFilters = this.saveFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    // this.openFactSheet = this.openFactSheet.bind(this);
    this.approveProduct = this.approveProduct.bind(this);
  }

  updateColumnName(event) {
    if (event.target.checked) {
      this.setState((prevState) => ({
        columns: [...prevState.columns, event.target.id]
      }));
    } else {
      const columns = this.state.columns;
      columns.splice(columns.indexOf(event.target.id), 1);
      this.setState({
        columns
      });
    }
  }

  async saveConfig() {
    await fetchAuthSession().then(() => {
      const config = {};
      config.headers = {
        'Authorization': cookies.get('Authorization'),
        'User-Specified': cookies.get('User-Specified'),
        'Type-Specified': cookies.get('Type-Specified')
      };
      const data = { structure_columns: this.state.columns };

      axios
        .patch(`${base_url}/structure-columns/${cookies.get('User-Specified')}`, data, config)
        .then(async () => { })
        .catch(() => {
          Toast.fail('Error Performing Action', 3000);
        });
    });
    Toast.success('Success', 1000, () => { });
  }

  async resetConfig() {
    const defaultColumns = [
      'Name',
      'Sector',
      'Initial Price',
      'Last Price',
      '% Change',
      'Barrier Price',
      'Distance To Barrier',
      'Autocall Level',
      'Distance To Autocall'
    ];
    Toast.loading('In Progress');
    this.setState({
      columns: defaultColumns
    });

    await fetchAuthSession().then(() => {
      const config = {};
      config.headers = {
        'Authorization': cookies.get('Authorization')
      };
      const data = { structure_columns: defaultColumns };

      axios
        .patch(`${base_url}/structure-columns/${cookies.get('User-Specified')}`, data, config)
        .then(async () => { })
        .catch(() => {
          Toast.fail('Error Performing Action', 3000);
        });
    });
    Toast.success('Success', 1000, () => { });
  }

  toggleCompoentShow(event) {
    if (event.target.id === 'Basic') {
      this.setState({
        show_basic: true,
        show_fundamentals: false,
        show_params: false
      });
    } else if (event.target.id === 'Fundamentals') {
      this.setState({
        show_basic: false,
        show_fundamentals: true,
        show_params: false
      });
    } else if (event.target.id === 'Data') {
      this.setState({
        show_basic: false,
        show_fundamentals: false,
        show_params: true
      });
    } else {
      this.setState({
        show_basic: true,
        show_fundamentals: true,
        show_params: false
      });
    }
  }

  updateFilter(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  async saveFilters() {
    Toast.loading('In Progress', () => { });

    await fetchAuthSession().then(() => {
      const config = {};
      config.params = {
        permanent: true,
        expired: false
      };

      if (this.state.coupon_type !== 'All') {
        config.params.screener = true;
        config.params.coupon_type = this.state.coupon_type;
      }
      if (this.state.coupon_min !== 0) {
        config.params.screener = true;
        config.params.coupon_min = this.state.coupon_min;
      }
      if (this.state.coupon_max !== 100) {
        config.params.screener = true;
        config.params.coupon_max = this.state.coupon_max;
      }
      if (this.state.tenor_min !== 0) {
        config.params.screener = true;
        config.params.tenor_min = this.state.tenor_min;
      }
      if (this.state.tenor_max !== 120) {
        config.params.screener = true;
        config.params.tenor_max = this.state.tenor_max;
      }
      if (this.state.barrier_min !== 0) {
        config.params.screener = true;
        config.params.barrier_min = this.state.barrier_min;
      }
      if (this.state.barrier_max !== 100) {
        config.params.screener = true;
        config.params.barrier_max = this.state.barrier_max;
      }
      if (this.state.strike_min !== 0) {
        config.params.screener = true;
        config.params.strike_min = this.state.strike_min;
      }
      if (this.state.strike_max !== 100) {
        config.params.screener = true;
        config.params.strike_max = this.state.strike_max;
      }
      config.headers = {
        'Authorization': cookies.get('Authorization'),
        'User-Specified': cookies.get('User-Specified'),
        'Type-Specified': cookies.get('Type-Specified')
      };
      axios
        .get(`${base_url}/structure-columns/${cookies.get('User-Specified')}`, config)
        .then(async (res) => {
          this.setState({
            columns: res.data.items
          });
        });

      if (cookies.get('Portfolio-Specified') != null) {
        config.params.portfolio_id = cookies.get('Portfolio-Specified');
      }
      axios.get(`${base_url}/dispersion-warrent-structure`, config).then(async (res) => {
        this.setState({
          product_details: res.data.items
        });
      });
      config.params = {};
      axios.get(`${base_url}/structure-underlying-count`, config).then(async (res) => {
        this.setState({
          underlying_count: res.data.item
        });
      });
    });
    Toast.success('Success', 1000, () => { });
  }

  async resetFilters() {
    this.setState({
      coupon_type: 'All',
      coupon_min: 0,
      coupon_max: 100,
      tenor_min: 0,
      tenor_max: 120,
      barrier_min: 0,
      barrier_max: 100,
      strike_min: 0,
      strike_max: 100
    });
    this.saveFilters();
  }

  async approveProduct(isinCode) {
    Toast.loading('In Progress', () => { });

    if (cookies.get('Type-Specified') !== 'Admin') {
      Toast.fail('You are not authorized to approve product', 3000, () => { });
      return;
    }

    await fetchAuthSession().then(() => {
      const config = {};
      config.headers = {
        'Authorization': cookies.get('Authorization'),
        'User-Specified': cookies.get('User-Specified'),
        'Type-Specified': cookies.get('Type-Specified')
      };

      config.params = {
        attribute: 'is_pending',
        value: null
      };
      axios
        .patch(`${base_url}/structure-attributes/${isinCode}`, {}, config)
        .then(async () => {
          Toast.success('Success', 1000, () => {
            window.location.href = '/structure/dispersion-warrent/ideas';
          });
        })
        .catch(() => {
          Toast.fail('Error Performing Action', 3000);
        });
    });
  }

  async sendEmail() {
    await fetchAuthSession().then(() => {
      const config = {};
      const data = {
        isin_code: this.state.isin_code,
        user_id: this.state.userId
      };
      config.headers = {
        'Authorization': cookies.get('Authorization'),
        'User-Specified': cookies.get('User-Specified'),
        'Type-Specified': cookies.get('Type-Specified')
      };
      axios
        .post(`${base_url}/send-email`, data, config)
        .then((res) => {
          Toast.success('Success', 1000, () => { });
        })
        .catch((error) => {
          console.log(error);
          Toast.fail('Error Performing Action', 3000);
        });
    });
  }

  async openFactSheet(isin_code) {
    window.open(
      `https://${bucket_name}.s3.${region}.amazonaws.com/structures/term-sheets/${isin_code}.pdf`,
      '_blank'
    );
  }

  async fetchData() {
    Toast.loading('In Progress', () => { });

    await fetchAuthSession().then(() => {
      const config = {};
      config.headers = {
        'Authorization': cookies.get('Authorization'),
        'User-Specified': cookies.get('User-Specified'),
        'Type-Specified': cookies.get('Type-Specified')
      };
      axios
        .get(`${base_url}/structure-columns/${cookies.get('User-Specified')}`, config)
        .then(async (res) => {
          this.setState({
            columns: res.data.items
          });
        });

      switch (this.state.props) {
        case '/structure/dispersion-warrent/details':
          config.params = {
            permanent: true,
            expired: false
          };
          break;
        case '/structure/dispersion-warrent/ideas':
          config.params = {
            permanent: false,
            expired: false
          };
          break;
        case '/structure/dispersion-warrent/expired/details':
          config.params = {
            permanent: true,
            expired: true
          };
          break;
        case '/structure/dispersion-warrent/pending/details':
          config.params = {
            is_pending: true,
            permanent: false
          };
          break;
        default:
          break;
      }

      if (cookies.get('Portfolio-Specified') != null) {
        config.params.portfolio_id = cookies.get('Portfolio-Specified');
      }
      axios.get(`${base_url}/dispersion-warrent-structure`, config).then(async (res) => {
        this.setState({
          product_details: res.data.items,
          userType: cookies.get('Type-Specified'),
          show_basic: this.state.props !== '/structure/dispersion-warrent/ideas',
          show_fundamentals: false,
          show_params: this.state.props === '/structure/dispersion-warrent/ideas',
        });
        Toast.success('Success', 1000, () => { });
      });
      config.params = {};
      axios.get(`${base_url}/structure-underlying-count`, config).then(async (res) => {
        this.setState({
          underlying_count: res.data.item
        });
      });
      config.params = {};
      axios.get(`${base_url}/structure-holding-count`, config).then(async (res) => {
        this.setState({
          holding_count: res.data.item
        });
      });
    });
  }

  async componentDidMount() {
    await this.fetchData();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.page !== prevProps.page) {
      await this.fetchData();
    }
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="container row">
          <div className="col-sm-11">
            <h3 style={{ color: 'red' }}>Structure Products</h3>
          </div>
          <div className="col-sm-1">
            <div className="btn-group">
              <button className="btn btn-primary" data-toggle="modal" data-target="#columns">
                <FaCog />
              </button>

              <button className="btn btn-primary" data-toggle="modal" data-target="#screener">
                <FaFilter />
              </button>
            </div>

            <div className="modal" id="columns">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">columns</h4>
                    <button type="button" className="close" data-dismiss="modal">
                      &times;
                    </button>
                  </div>

                  <div className="modal-body">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={this.updateColumnName}
                            id="Code"
                            checked={this.state.columns.includes('Code') && true}
                          />
                          <label className="form-group form-check-label hidden">Code</label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={this.updateColumnName}
                            id="Sector"
                            checked={this.state.columns.includes('Sector') && true}
                          />
                          <label className="form-group form-check-label hidden">Sector</label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={this.updateColumnName}
                            id="Industry"
                            checked={this.state.columns.includes('Industry') && true}
                          />
                          <label className="form-group form-check-label hidden">Industry</label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={this.updateColumnName}
                            id="Strike Price"
                            checked={this.state.columns.includes('Strike Price') && true}
                          />
                          <label className="form-group form-check-label hidden">Strike Price</label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={this.updateColumnName}
                            id="Distance To Strike"
                            checked={this.state.columns.includes('Distance To Strike') && true}
                          />
                          <label className="form-group form-check-label hidden">
                            Distance To Strike
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={this.updateColumnName}
                            id="Next Autocall Level"
                            checked={this.state.columns.includes('Next Autocall Level') && true}
                          />
                          <label className="form-group form-check-label hidden">
                            Next Autocall Level
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={this.updateColumnName}
                            id="Type"
                            checked={this.state.columns.includes('Type') && true}
                          />
                          <label className="form-group form-check-label hidden">Type</label>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={this.updateColumnName}
                            id="Fundamentals"
                            checked={this.state.columns.includes('Fundamentals') && true}
                          />
                          <label className="form-group form-check-label hidden">Funamentals</label>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={this.updateColumnName}
                            id="Analyst Ratings"
                            checked={this.state.columns.includes('Analyst Ratings') && true}
                          />
                          <label className="form-group form-check-label hidden">
                            Analyst Ratings
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer btn-group">
                    <button
                      type="button"
                      className="btn btn-primary btn-block"
                      data-dismiss="modal"
                      onClick={this.saveConfig}
                    >
                      Save Configuration <FaCloud />
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger btn-block"
                      data-dismiss="modal"
                      onClick={this.resetConfig}
                    >
                      Reset Configuration <FaTrash />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal" id="screener">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">Filters</h4>
                    <button type="button" className="close" data-dismiss="modal">
                      &times;
                    </button>
                  </div>

                  <div className="modal-body">
                    <div className="form-check">
                      <label className="form-group form-label">Strike:</label>
                      <div className="input-group mb-3">
                        <input
                          type="number"
                          className="form-control"
                          onChange={this.updateFilter}
                          id="strike_min"
                          value={this.state.strike_min}
                        />
                        <input
                          type="number"
                          className="form-control"
                          onChange={this.updateFilter}
                          id="strike_max"
                          value={this.state.strike_max}
                        />
                      </div>
                      <button
                        type="button"
                        className="btn btn-danger"
                        data-dismiss="modal"
                        onClick={this.saveFilters}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                        onClick={this.resetFilters}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="btn-group" style={{ width: '100%' }}>
          <button
            type="button"
            className="btn btn-secondary"
            id="Data"
            onClick={this.toggleCompoentShow}
          >
            Data
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            id="Basic"
            onClick={this.toggleCompoentShow}
          >
            Basic
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            id="Fundamentals"
            onClick={this.toggleCompoentShow}
          >
            Fundamentals
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            id="All"
            onClick={this.toggleCompoentShow}
          >
            All
          </button>
        </div>
        {this.state.show_params ? (
          <table className="table table-sm">
            <thead className="table-dark">
              <tr>
                <th style={{ position: 'sticky', top: 50 }}>ISIN CODE</th>
                {this.state.props !== '/structure/dispersion-warrent/ideas' && (
                  <th style={{ position: 'sticky', top: 50 }}>Issuer</th>
                )}
                <th style={{ position: 'sticky', top: 50 }}>Underlying</th>
                <th style={{ position: 'sticky', top: 50 }}>Currency</th>
                <th style={{ position: 'sticky', top: 50 }}>Maturity</th>
                <th style={{ position: 'sticky', top: 50 }}>Strike</th>
                <th style={{ position: 'sticky', top: 50 }}>Special Features</th>
                {this.state.props !== '/structure/dispersion-warrent/ideas' && (
                  <th style={{ position: 'sticky', top: 50 }}>Basket Price</th>
                )}
              </tr>
            </thead>
            <tbody className="custom-info">
              {this.state.product_details.map((isin_data, index) => {
                return (
                  <tr key={index}>
                    <td
                      style={{
                        backgroundColor: '#002850',
                        color: '#ffffff',
                        textDecoration: 'none',
                        border: '1px solid white'
                      }}
                    >
                      <strong dataToggle="tooltip" title={isin_data.last_updated}>
                        <Link
                          to={`/structure/dispersion-warrent/report?ISIN=${isin_data.isin_code}`}
                        >
                          {isin_data.isin_code}
                        </Link>
                      </strong>
                    </td>
                    {this.state.props !== '/structure/dispersion-warrent/ideas' && (
                      <td>{isin_data.issuer ? isin_data.issuer : '-'}</td>
                    )}
                    <td>{getCodes(isin_data.underlying)}</td>
                    <td>{isin_data.currency ? isin_data.currency : '-'}</td>
                    <td>{isin_data.maturity ? isin_data.maturity : '-'}</td>
                    <td>{isin_data.strike ? isin_data.strike : '-'}</td>
                    <td>{isin_data.special_features ? isin_data.special_features : '-'}</td>
                    {this.state.props !== '/structure/dispersion-warrent/ideas' && (
                      <td>{isin_data.basket_price_latest ? isin_data.basket_price_latest : '-'}</td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <table className="table table-sm">
            <thead className="table-dark">
              <tr>
                <th style={{ position: 'sticky', top: 50 }}>ISIN Code</th>
                <th style={{ position: 'sticky', top: 50 }}>Parameters</th>
                <th style={{ position: 'sticky', top: 50 }}>Dates</th>

                {this.state.columns.includes('Name') && (
                  <th style={{ position: 'sticky', top: 50 }}>Name</th>
                )}
                <th style={{ position: 'sticky', top: 50 }}></th>
                {this.state.show_basic && (
                  <>
                    {this.state.columns.includes('Code') && (
                      <th style={{ position: 'sticky', top: 50 }}>Code</th>
                    )}
                    {this.state.columns.includes('Sector') && (
                      <th style={{ position: 'sticky', top: 50 }}>Sector</th>
                    )}
                    {this.state.columns.includes('Industry') && (
                      <th style={{ position: 'sticky', top: 50 }}>Industry</th>
                    )}
                    {this.state.columns.includes('Initial Price') && (
                      <th style={{ position: 'sticky', top: 50 }}>Initial Price</th>
                    )}
                    {this.state.columns.includes('Last Price') && (
                      <th style={{ position: 'sticky', top: 50 }}>Last Price</th>
                    )}
                    {this.state.columns.includes('% Change') && (
                      <th style={{ position: 'sticky', top: 50 }}>% Change</th>
                    )}
                    {this.state.columns.includes('Strike Price') && (
                      <th style={{ position: 'sticky', top: 50 }}>Strike Price</th>
                    )}
                    {this.state.columns.includes('Distance To Strike') && (
                      <th style={{ position: 'sticky', top: 50 }}>Distance To Strike</th>
                    )}
                    {this.state.columns.includes('Basket Price Latest') && (
                      <th style={{ position: 'sticky', top: 50 }}>Basket Price Latest</th>
                    )}
                    {this.state.columns.includes('Status') && (
                      <th style={{ position: 'sticky', top: 50 }}>Status</th>
                    )}
                  </>
                )}

                {this.state.show_fundamentals && (
                  <>
                    <th style={{ position: 'sticky', top: 50 }}></th>
                    <th style={{ position: 'sticky', top: 50 }}>Trailing PE</th>
                    <th style={{ position: 'sticky', top: 50 }}>Forward PE</th>
                    <th style={{ position: 'sticky', top: 50 }}>MCap to Revenue</th>
                    <th style={{ position: 'sticky', top: 50 }}>ROE</th>
                    <th style={{ position: 'sticky', top: 50 }}>Dividend Yield</th>
                    <th style={{ position: 'sticky', top: 50 }}></th>
                    <th style={{ position: 'sticky', top: 50 }}>Consensus Ratings</th>
                    <th style={{ position: 'sticky', top: 50 }}>Buy</th>
                    <th style={{ position: 'sticky', top: 50 }}>Hold</th>
                    <th style={{ position: 'sticky', top: 50 }}>Sell</th>
                    <th style={{ position: 'sticky', top: 50 }}>12 Months Target</th>
                    <th style={{ position: 'sticky', top: 50 }}>Return</th>
                  </>
                )}
                <th style={{ position: 'sticky', top: 50 }}></th>
              </tr>
            </thead>
            <tbody className="custom-info">
              {this.state.product_details.map((isin_data, index) => {
                return (
                  <>
                    <tr>
                      <td
                        key={isin_data}
                        className="table-dark"
                        rowSpan={isin_data.underlying.length + 1}
                        style={{
                          backgroundColor: '#002850',
                          color: '#ffffff',
                          textDecoration: 'none',
                          border: '1px solid white'
                        }}
                      >
                        <strong dataToggle="tooltip" title={isin_data.last_updated}>
                          <Link
                            to={`/structure/dispersion-warrent/report?ISIN=${isin_data.isin_code}`}
                          >
                            {isin_data.isin_code}
                          </Link>
                        </strong>
                        <br />
                        <strong>{isin_data.issuer}</strong>
                        <br />
                        <strong>
                          {isin_data.notional_quantity != null &&
                            isin_data.notional_quantity !== 0 &&
                            isin_data.notional_quantity.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 2
                            })}
                        </strong>
                        <br />
                        <strong>
                          {isin_data.basket_price_latest != null &&
                            isin_data.basket_price_latest !== 0 &&
                            isin_data.basket_price_latest.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 2
                            })}
                        </strong>
                      </td>
                      <td
                        className="table-dark"
                        rowSpan={isin_data.underlying.length + 1}
                        style={{
                          backgroundColor: '#002850',
                          color: '#ffffff',
                          textDecoration: 'none',
                          border: '1px solid white',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        <strong>ST: {isin_data.strike + '%'}</strong>
                      </td>
                      <td
                        className="table-dark"
                        rowSpan={isin_data.underlying.length + 1}
                        style={{
                          backgroundColor: '#002850',
                          color: '#ffffff',
                          textDecoration: 'none',
                          border: '1px solid white',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        <strong>Fn: {dayjs(isin_data.final_fixing_date).format('DD/MM/YY')}</strong>
                        <br />
                        <strong>{isin_data.maturity} Months</strong>
                        <br />
                        <strong>AC Fq: {isin_data.autocall_frequency}</strong>
                      </td>
                    </tr>
                    {isin_data.underlying.map((scrip_data, scrip_index) => {
                      return (
                        <tr key={scrip_data}>
                          {
                            <td>
                              <strong>{scrip_data[column_names.Name].substring(0, 18)}</strong>
                              {scrip_data[column_names.Code].indexOf(' INDEX') !== -1 && (
                                <Link
                                  to={`/product/index-components?code=${scrip_data[column_names.Code]
                                    }`}
                                >
                                  <FaLayerGroup />
                                </Link>
                              )}
                            </td>
                          }
                          <td>
                            {this.state.underlying_count.length !== 0 &&
                              this.state.props !== '/structure/pending/details' &&
                              this.state.underlying_count[scrip_data[column_names.Code]] &&
                              this.state.holding_count.length !== 0 &&
                              this.state.props !== '/structure/pending/details' && (
                                <span
                                  className={
                                    this.state.underlying_count.length !== 0 &&
                                      this.state.props !== '/structure/pending/details' &&
                                      this.state.holding_count[scrip_data[column_names.Code]]
                                      ? 'badge badge-danger'
                                      : 'badge badge-primary'
                                  }
                                >
                                  {this.state.underlying_count[scrip_data[column_names.Code]]}
                                </span>
                              )}
                          </td>
                          {this.state.show_basic && (
                            <>
                              {this.state.columns.includes('Code') &&
                                this.state.columns.includes('Code') && (
                                  <td>
                                    <Link
                                      to={`/product/equity?code=${scrip_data[column_names.Code]}`}
                                    >
                                      {scrip_data[column_names.Code]}
                                    </Link>
                                  </td>
                                )}
                              {this.state.columns.includes('Sector') &&
                                this.state.columns.includes('Sector') && (
                                  <td>
                                    {scrip_data[column_names.Sector]
                                      ? scrip_data[column_names.Sector].substring(0, 18)
                                      : '-'}
                                  </td>
                                )}
                              {this.state.columns.includes('Industry') &&
                                this.state.columns.includes('Industry') && (
                                  <td>{scrip_data[column_names.Industry]}</td>
                                )}
                              {this.state.columns.includes('Initial Price') &&
                                this.state.columns.includes('Initial Price') && (
                                  <td>
                                    {scrip_data[column_names['Initial Price']].toLocaleString(
                                      undefined,
                                      { minimumFractionDigits: 0, maximumFractionDigits: 2 }
                                    )}
                                  </td>
                                )}
                              {this.state.columns.includes('Last Price') &&
                                this.state.columns.includes('Last Price') && (
                                  <td>
                                    {scrip_data[column_names['Last Price']].toLocaleString(
                                      undefined,
                                      { minimumFractionDigits: 0, maximumFractionDigits: 2 }
                                    )}
                                  </td>
                                )}
                              {this.state.columns.includes('% Change') &&
                                this.state.columns.includes('% Change') && (
                                  <td
                                    style={{
                                      color:
                                        scrip_data[column_names['% Change']] > 0 ? 'green' : 'red'
                                    }}
                                  >
                                    <strong>
                                      {scrip_data[column_names['% Change']].toLocaleString(
                                        undefined,
                                        { minimumFractionDigits: 0, maximumFractionDigits: 2 }
                                      )}
                                      %
                                    </strong>
                                  </td>
                                )}
                              {this.state.columns.includes('Strike Price') && (
                                <td>
                                  {scrip_data[column_names['Strike Price']].toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 0, maximumFractionDigits: 2 }
                                  )}
                                </td>
                              )}
                              {this.state.columns.includes('Distance To Strike') && (
                                <td
                                  style={{
                                    color:
                                      scrip_data[column_names['Distance To Strike']] > 0
                                        ? 'green'
                                        : 'red'
                                  }}
                                >
                                  <strong>
                                    {scrip_data[column_names['Distance To Strike']].toLocaleString(
                                      undefined,
                                      { minimumFractionDigits: 0, maximumFractionDigits: 2 }
                                    )}
                                    %
                                  </strong>
                                </td>
                              )}
                              {this.state.columns.includes('Basket Price Latest') && (
                                <td>{isin_data[column_names['Basket Price Latest']]}</td>
                              )}
                              {this.state.columns.includes('First Autocall Date') && (
                                <td>
                                  {dayjs(isin_data[column_names['First Autocall Date']]).format(
                                    'DD/MM/YY'
                                  )}
                                </td>
                              )}
                              {this.state.columns.includes('Next Autocall Date') && (
                                <td>
                                  {dayjs(isin_data[column_names['Next Autocall Date']]).format(
                                    'DD/MM/YY'
                                  )}
                                </td>
                              )}
                              {this.state.columns.includes('Next Autocall %') && (
                                <td>{isin_data[column_names['Next Autocall %']]}</td>
                              )}
                              {this.state.columns.includes('Next Autocall Level') && (
                                <td>
                                  {scrip_data[column_names['Next Autocall Level']].toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 0, maximumFractionDigits: 2 }
                                  )}
                                </td>
                              )}
                              {this.state.columns.includes('Status') && (
                                <td>{isin_data[column_names.Status]}</td>
                              )}
                              {this.state.columns.includes('Type') && (
                                <td>{isin_data[column_names.Type]}</td>
                              )}
                            </>
                          )}
                          {this.state.show_fundamentals && (
                            <>
                              <td></td>
                              <td>
                                {scrip_data.trailing_pe
                                  ? scrip_data.trailing_pe.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 2
                                  })
                                  : '-'}
                              </td>
                              <td>
                                {scrip_data.forward_pe
                                  ? scrip_data.forward_pe.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 2
                                  })
                                  : '-'}
                              </td>
                              <td>
                                {scrip_data.market_capitalization_to_revenue_ttm
                                  ? scrip_data.market_capitalization_to_revenue_ttm.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 0, maximumFractionDigits: 2 }
                                  )
                                  : '-'}
                              </td>
                              <td>
                                {scrip_data.return_on_equity_ttm
                                  ? scrip_data.return_on_equity_ttm.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 2
                                  })
                                  : '-'}
                              </td>
                              <td>
                                {scrip_data.dividend_yield
                                  ? scrip_data.dividend_yield.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 2
                                  })
                                  : '-'}
                              </td>
                              <td></td>
                              <td>{scrip_data.rating ? scrip_data.rating : '-'}</td>
                              {/* <td style={{color: "green"}}><strong>{scrip_data["strong_buy"]? parseInt(scrip_data["strong_buy"]) + parseInt(scrip_data["buy"]): "-"}</strong></td> */}
                              <td style={{ color: 'green' }}>
                                <strong>
                                  {scrip_data.buy != null && scrip_data.strong_buy != null
                                    ? scrip_data.buy + scrip_data.strong_buy
                                    : '-'}
                                </strong>
                              </td>
                              <td style={{ color: 'gold' }}>
                                <strong>
                                  {scrip_data.hold != null ? scrip_data.hold != null : '-'}
                                </strong>
                              </td>
                              <td style={{ color: 'red' }}>
                                <strong>
                                  {scrip_data.sell != null && scrip_data.strong_sell != null
                                    ? scrip_data.sell + scrip_data.strong_sell
                                    : '-'}
                                </strong>
                              </td>
                              {/* <td style={{color: "red"}}><strong>{scrip_data["sell"]? parseInt(scrip_data["sell"]) + parseInt(scrip_data["strong_sell"]): "-"}</strong></td> */}
                              <td>
                                {scrip_data.wall_street_target_price
                                  ? scrip_data.wall_street_target_price.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 2
                                  })
                                  : '-'}
                              </td>
                              <td>
                                {scrip_data.return_potential
                                  ? scrip_data.return_potential.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 2
                                  }) + '%'
                                  : '-'}
                              </td>
                            </>
                          )}
                          {scrip_index === 0 && (
                            <td rowSpan={isin_data.underlying.length}>
                              <StructurePopover
                                isin_code={isin_data.isin_code}
                                userType={this.state.userType}
                                userId={cookies.get('User-Specified')}
                                TermSheet={isin_data.term_sheet}
                                path={this.props.page}
                                sendEmailHandler={this.sendEmail}
                                openFactSheetHandler={this.openFactSheet}
                                approveProductHandler={this.approveProduct}
                              />
                            </td>
                          )}
                        </tr>
                      );
                    })}
                    <tr>
                      <td
                        colSpan={this.state.columns.length + 1}
                        className="blank-row"
                        style={{ backgroundColor: ' #ffffff', height: '10px' }}
                      ></td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

export default DispersionWarrentStructures;
